import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

const Modal = ({
  isOpen,
  onClose,
  title,
  size = 'md',
  children,
  footer,
  className = '',
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Escape closes it. Clicking the overlay and the × already did; Escape is
  // what people try first and it did nothing, which left the overlay sitting
  // over the page swallowing clicks.
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Render into document.body so the overlay isn't trapped inside a parent
  // stacking context (e.g. .main-content), which would let the railbar paint
  // over it despite its high z-index.
  return createPortal(
    <div className="p-modal-overlay" onClick={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
        className={`p-modal p-modal--${size} ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="p-modal__header">
            <h2 className="p-modal__title">{title}</h2>
            <button className="p-modal__close" onClick={onClose} type="button">
              &times;
            </button>
          </div>
        )}
        <div className="p-modal__body">{children}</div>
        {footer && <div className="p-modal__footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
